/**
 * Отладочные параметры адреса (`?speed`, `?mock`, `?fake`, `?pause`, `?bench`, `?wave`, `?seed`, `?auto`) — только для
 * e2e и разработки: работают на локальном хосте, на проде их нет (ISSUE-48). Темп журналов всё равно проверяет сервер.
 */
const LOCAL_HOSTS: readonly string[] = ["localhost", "127.0.0.1", "[::1]"];

/** Параметры адреса для отладки: на чужом хосте — пусто. */
export function debugParams(search: string, hostname: string): URLSearchParams {
  return new URLSearchParams(LOCAL_HOSTS.includes(hostname) ? search : "");
}
